// import Select from 'react-select'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
// import clsx from 'clsx'

const Additional: React.FC = () => {
	return (
		<div className="card border border-kumopack-grey-200">
			<div className="card-header border-0 mt-4">
				<div className="card-title">
					{/* Title */}
					<div>
						<h4 className="text-kumopack-grey-900 fw-bold mb-2">5. อื่นๆ</h4>
						<div className="text-kumopack-grey-600 fs-6">กลุ่มการแสดงผลสินค้า</div>
					</div>
				</div>
				<div className="mt-2 separator border-1px w-100 border-kumopack-grey-200"></div>
			</div>

			<div className="card-body">
				<div className="mb-5 d-flex flex-column flex-xl-row align-items-xl-">
					<div className="col-12">
						<FormGenerator
							label="กลุ่มแสดงสินค้า"
							formKey="etc"
							inputType="plain"
							isHorizontal={!isMobileDevice()}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Additional
